import { render, staticRenderFns } from "./ServerConfig.vue?vue&type=template&id=68415e84&scoped=true"
import script from "./ServerConfig.vue?vue&type=script&lang=js"
export * from "./ServerConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68415e84",
  null
  
)

export default component.exports